import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { useBlogStore, Blogpost, BlogFilter } from "@/ts/stores/blog";
import { Spinner } from "@/ts/components/elements";
import BlogCard from "@/ts/components/blog/card.vue";
import { useDebounceFn } from "@vueuse/core";

/**
 * Interfaces
 */
interface Props {}

interface BlogpostFilter {
    categoryId: number | null;
}

/**
 * Use functions
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'overview',
  setup(__props: any, { expose }) {
  expose();

const props = __props as {}

const blogpostStore = useBlogStore();

/**
 * Private variables
 */

const search = ref();
const date = ref();
const page = ref(1);
const per_page = 9;
const end_reached = ref(false);
const loading = ref(true);
const debounceWaiting = ref(false);
const filter = ref<BlogpostFilter>({
    categoryId: null,
});

/**
 * Retrieve API data
 */
const promises = [];
promises.push(blogpostStore.indexBlogposts());
Promise.all(promises).then(() => (loading.value = false));

/**
 * Computed variables
 */
const blogposts = computed<Blogpost[]>(() => {
    const blogposts = blogpostStore.all;
    //return props.full ? blogposts : blogposts.slice(0, 5);
    return blogposts;
});

const canLoadMore = computed<boolean | undefined>(() => {
    return !loading.value && blogposts.value.length > 0 && blogposts.value.length % per_page === 0 && !end_reached.value;
});

/**
 * Functions
 */
function toggleFilter(id: number) {
    if (filter.value.categoryId === id) {
        filter.value.categoryId = null;
    } else {
        filter.value.categoryId = id;
    }

    loadMore(false);
}

function resetPagination() {
    end_reached.value = false;
    page.value = 1;
}

function loadMore(next_page: boolean = true) {
    debounceWaiting.value = true;
    loadMoreDebounced(next_page);
}

const loadMoreDebounced = useDebounceFn((next_page: boolean = true) => {
    debounceWaiting.value = false;

    if (next_page) {
        page.value++;
    } else {
        resetPagination();
    }

    loading.value = true;

    const blogpostFilter: BlogFilter = {
        page: page.value,
    };

    const oldLength = blogpostStore.all.length;
    blogpostStore.indexBlogposts(blogpostFilter).then(() => {
        const newLength = blogpostStore.all.length;
        end_reached.value = oldLength === newLength;
        loading.value = false;
    });
}, 1000);

const __returned__ = { blogpostStore, props, search, date, page, per_page, end_reached, loading, debounceWaiting, filter, promises, blogposts, canLoadMore, toggleFilter, resetPagination, loadMore, loadMoreDebounced, Spinner, BlogCard }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})